import c from "./index15.js";
import { openBlock as t, createElementBlock as r, createElementVNode as s, Fragment as n, renderList as i, withModifiers as a, toDisplayString as l } from "vue";
import "./index16.js";
import p from "../../../../_virtual/index.js";
const d = {
  class: "links",
  "aria-label": "secondary"
}, f = { class: "links-left" }, u = ["href", "target", "onClick"], _ = { class: "links-right" }, h = ["href", "target", "onClick"];
function m(o, g, v, k, C, y) {
  return t(), r("nav", d, [
    s("div", f, [
      (t(!0), r(n, null, i(o.leftColumnLinks, (e) => (t(), r("a", {
        key: e.title,
        href: e.value,
        target: e.target,
        onClick: a(e.open, ["prevent"])
      }, l(o.t(e.title)), 9, u))), 128))
    ]),
    s("div", _, [
      (t(!0), r(n, null, i(o.rightColumnLinks, (e) => (t(), r("a", {
        key: e.title,
        href: e.value,
        target: e.target,
        onClick: a(e.open, ["prevent"])
      }, l(o.t(e.title)), 9, h))), 128))
    ])
  ]);
}
const b = /* @__PURE__ */ p(c, [["render", m]]);
export {
  b as default
};
//# sourceMappingURL=index8.js.map
